import { Component } from 'utils';

@Component({
    controllerAs: 'vm',
    template: require('./reports.tpl.html')
})
export class ReportsSummrizeComponent {
    static $inject = ['store'];

    constructor(store) {
        this.store = store;
    }

    filter(data) {
        this.report = data;
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/reports/report-summrize/reports.js